import { PlatformLocation } from '@angular/common';

export const getBaseHref = (platformLocation: PlatformLocation): string => {
	return platformLocation.getBaseHrefFromDOM();
};
